import TwoFActionTypes from './2FA-types'

export const startChange2FaStatus = data => ({
    type: TwoFActionTypes.STATUS_CHANGE_OF_2FA,
    payload: data,
})

export const set2FaType = data => ({
    type: TwoFActionTypes.SET_2FA_TYPE,
    payload: data,
})

export const failure2fa = data => ({
    type: TwoFActionTypes.FAILURE_2FA,
    payload: data,
})

//****************  Change 2fa authentication  ********************* */

export const startChange2FaAuthenticationType = data => ({
    type: TwoFActionTypes.START_CHANGE_2FA_AUTHENTICATION_TYPE,
    payload: data,
})
export const verifyGoogleAuthCode = data => ({
    type: TwoFActionTypes.VERIFY_GOOGLE_AUTH_CODE,
    payload: data,
})
export const successChange2FaAuthenticationType = data => ({
    type: TwoFActionTypes.SUCCESS_CHANGE_2FA_AUTHENTICATION_TYPE,
    payload: data,
})
export const finishChange2FaAuthenticationType = data => ({
    type: TwoFActionTypes.FINISH_CHANGE_2FA_AUTHENTICATION_TYPE,
    payload: data,
})
export const failureChange2FaAuthenticationType = data => ({
    type: TwoFActionTypes.FAILURE_CHANGE_2FA_AUTHENTICATION_TYPE,
    payload: data,
})

//****************  Start google authentication setup  ********************* */

export const startGoogleAuthenticationSetup = data => ({
    type: TwoFActionTypes.START_GOOGLE_AUTHENTICATION_SETUP,
    payload: data,
})
export const successGoogleAuthenticationSetup = data => ({
    type: TwoFActionTypes.SUCCESS_GOOGLE_AUTHENTICATION_SETUP,
    payload: data,
})
export const finishGoogleAuthenticationSetup = data => ({
    type: TwoFActionTypes.FINISH_GOOGLE_AUTHENTICATION_SETUP,
    payload: data,
})
export const failureGoogleAuthenticationSetup = data => ({
    type: TwoFActionTypes.FAILURE_GOOGLE_AUTHENTICATION_SETUP,
    payload: data,
})

//****************  Start google authentication setup  ********************* */

export const startGoogleAuthenticationVerify = data => ({
    type: TwoFActionTypes.START_GOOGLE_AUTHENTICATION_VERIFY,
    payload: data,
})
export const successGoogleAuthenticationVerify = data => ({
    type: TwoFActionTypes.SUCCESS_GOOGLE_AUTHENTICATION_VERIFY,
    payload: data,
})
export const finishGoogleAuthenticationVerify = data => ({
    type: TwoFActionTypes.FINISH_GOOGLE_AUTHENTICATION_VERIFY,
    payload: data,
})
export const failureGoogleAuthenticationVerify = data => ({
    type: TwoFActionTypes.FAILURE_GOOGLE_AUTHENTICATION_VERIFY,
    payload: data,
})

//****************  Start fetch google authentication types  ********************* */

export const startFetchGoogleAuthenticationTypes = data => ({
    type: TwoFActionTypes.START_FETCH_AUTHENTICATION_TYPES,
    payload: data,
})
export const successFetchGoogleAuthenticationTypes = data => ({
    type: TwoFActionTypes.SUCCESS_FETCH_AUTHENTICATION_TYPES,
    payload: data,
})
export const finishFetchGoogleAuthenticationTypes = data => ({
    type: TwoFActionTypes.FINISH_FETCH_AUTHENTICATION_TYPES,
    payload: data,
})
export const failureFetchGoogleAuthenticationTypes = data => ({
    type: TwoFActionTypes.FAILURE_FETCH_AUTHENTICATION_TYPES,
    payload: data,
})
